import { Offer } from '@wwt/entities/search-response'
import { showOfferConfigurationOfferStatuses } from '@wwt/shared/config'
import { extractFeaturesFromOffer, groupAllFeatures } from '@wwt/shared/utils'

export const useRemoteSection = (
	tabName: string | undefined,
	offer: Offer | null
) => {
	if (!tabName || !offer) {
		return {
			remoteFeatureGroups: []
		}
	}

	const remoteFeatures = extractFeaturesFromOffer(
		offer,
		undefined,
		undefined,
		feature => feature.group?.tabName === tabName
	)

	const remoteFeatureGroups = groupAllFeatures(remoteFeatures)

	const isOfferConfigurationStatuses =
		offer?.IDs.status &&
		showOfferConfigurationOfferStatuses.includes(offer?.IDs.status)

	return {
		remoteFeatureGroups,
		isOfferConfigurationDisabled: !isOfferConfigurationStatuses
	}
}
